'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = expireAll;

var _list2 = require('./_list');

var _list3 = _interopRequireDefault(_list2);

var _expireRange = require('./expire-range');

var _expireRange2 = _interopRequireDefault(_expireRange);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function expireAll(root, listName) {
    var list = (0, _list3.default)(root, listName);
    var end = Math.max(0, list.entries.length - 1);

    return (0, _expireRange2.default)(root, listName, 0, end);
}